import { safeBtoa } from './safeBtoa';

/**
 * Creates a token-friendly short equipment ID from the full deterministic ID
 * Example: reg_VSL001-25_ffe_extinguisher_control_position_bridge_ → EXT–BRID–VSL001-25–0RK5P
 */
export function toShortEquipId(fullId) {
  if (!fullId) return 'EQP–UNK–UNK–00000';
  
  // 1) Derive equipment type
  const type = fullId.includes('_extinguisher_') ? 'EXT' :
               fullId.includes('_fixedSystem_') ? 'FIX' :
               fullId.includes('_blanket_') ? 'BLK' :
               fullId.includes('_hose_') ? 'HSE' :
               fullId.includes('_lifejacket_') ? 'LJK' :
               fullId.includes('_liferaft_') ? 'LRF' :
               fullId.includes('_lifebuoy_') ? 'LBY' :
               fullId.includes('_epirb_') ? 'EPB' :
               fullId.includes('_flare_') ? 'FLR' : 'EQP';
  
  // 2) Extract location (last meaningful part)
  const parts = fullId.split('_');
  const loc = (parts[parts.length - 2] || parts[parts.length - 1] || 'LOC')
    .slice(0, 4).toUpperCase();
  
  // 3) Extract vessel ID
  const vessel = (fullId.match(/reg_(.+?)_/i)?.[1] || 'VSL')
    .replace(/[^A-Z0-9-]/gi, '').toUpperCase().slice(0, 8);
  
  // 4) Create checksum from full ID (last 5 chars of base64)
  //    safeBtoa (FT-443): byte-identical to btoa for all inputs btoa accepts;
  //    only rescues ids with Unicode chars > 0xFF that previously crashed.
  const tail = safeBtoa(fullId).replace(/[^A-Z0-9]/gi, '').slice(-5).toUpperCase();
  
  return `${type}–${loc}–${vessel}–${tail}`;
}